import { FunctionalComponent, h } from 'preact';
import { MutableRef } from 'preact/hooks';
import { TickIcon } from "@uw/icons";
import { Language } from '../../constants/languages';
import { onKeyboardSelection } from '../../helpers/operators';
import { useNavigationReader } from '../../services/use-navigation-reader';
import { useDynamicSize } from '../oversized-widget/use-dynamic-size';

interface LanguagesListProps {
    languages: Language[];
    setIsListFocused: (value: boolean) => void;
    active: Language;
    languagesRef: MutableRef<HTMLButtonElement[]>;
    focusedItem: MutableRef<number>;
    selectLanguage: (lang: Language) => void;
}


export const LanguagesList: FunctionalComponent<LanguagesListProps> = (props) => {
    const {languagesRef, selectLanguage, focusedItem, languages, active, setIsListFocused} = props;
    const size = useDynamicSize();
    const { sendNavigationReaderRequest } = useNavigationReader();

    const isActive = (lang: Language) => lang.value === active.value;
    const readContent = (e) => {
        const label = e.target.innerText;
        if(label) {
            sendNavigationReaderRequest(label);
        }

    };
    return <ul className="uwaw-lang-list">
        {languages.map((languageEntry, index) => (
            <li key={languageEntry.value} className="uwaw-lang-list__item">

                <button type="button" className={`uwaw-lang-list__btn ${isActive(languageEntry) ? 'active' : ''}`}
                        ref={(el) => {
                            // if (index === 0) el.focus();
                            languagesRef.current[index] = el;
                        }}
                        onClick={() => {
                            selectLanguage(languageEntry)
                            focusedItem.current = null;
                        }}
                        onKeyUp={onKeyboardSelection(() => selectLanguage(languageEntry))}
                        onFocus={(e) => {
                            if (focusedItem.current) {
                                setIsListFocused(true);
                                focusedItem.current = index;
                                readContent(e);
                            }
                        }}>

						<span className="uwaw-lang-list__flag">
							<span className={`fflag fflag-${languageEntry.flag} ff-sm`}/>
						</span>
                        <span className="uwaw-lang-list__value">
							<span className="uwaw-lang-list__name">{languageEntry.name}</span>
						</span>
                        <span className="uwaw-lang-list__active-icon">
                            <TickIcon width={size(9, 11)} height={size(6, 8)}/>
                        </span>

                </button>
            </li>
        ))}
    </ul>
}
